export class ServerConfig {
  public static mediaBucket = 'oneclick.media';
  public static cognitoUserPoolId = 'us-west-2_K4dVngaPx';
  public static cognitoClientId = '5mra5m4aa966ghpkhk8kb9p0eh';
  public static gatewayDev = 'api.oneclick.community';
  public static gatewayProd = 'api.oneclick.community';
  public static socketDev = 'ws.oneclick.community';
  public static socketProd = 'ws.oneclick.community';
}